import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import TopNav from "../components/TopNav";
import AuthPage from "./AuthPage";
import { Link } from "react-router-dom"; // ✅ Import Link
import "../App.css";

function WishList() {
  const [user, setUser] = useState(null);
  const [jobs, setJobs] = useState([]);

  // Watch for login
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return () => unsub();
  }, []);

  // Fetch favorite jobs
  useEffect(() => {
    const fetchWishListJobs = async () => {
      if (!user) return;

      const favRef = collection(db, `users/${user.uid}/favourite`);
      const favSnap = await getDocs(favRef);

      const promises = favSnap.docs.map(async (docSnap) => {
        const jobRef = doc(db, "items", docSnap.id);
        const jobSnap = await getDoc(jobRef);
        if (jobSnap.exists()) {
          return { id: jobSnap.id, ...jobSnap.data() };
        }
        return null;
      });

      const results = await Promise.all(promises);
      setJobs(results.filter(Boolean)); // remove nulls
    };

    fetchWishListJobs();
  }, [user]);

  if (!user) return <AuthPage />;

  return (
    <div className="wish-container">
      <TopNav />
      <h2>Favorites</h2>
      {jobs.length === 0 ? (
        <p>No favorite jobs saved.</p>
      ) : (
        <ul className="job-list">
          {jobs.map((job) => (
            <Link to={`/item/${job.id}`} key={job.id} className="job-tile-link">
              <li className="job-tile">
                <img
                  src={job.image || "/no_image.png"}
                  alt="Job"
                  className="job-image"
                />
                <div className="job-info">
                  <h3 className="job-title">{job.name}</h3>
                  <p className="job-location">{job.place}</p>
                  <p className="job-type">{job.type}</p>
                </div>
              </li>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}

export default WishList;
